import { render, staticRenderFns } from "./DonutChart14.vue?vue&type=template&id=3b04b7a7&scoped=true"
import script from "./DonutChart14.vue?vue&type=script&lang=js"
export * from "./DonutChart14.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b04b7a7",
  null
  
)

export default component.exports